import AdminLoadable from 'components/core/AdminLoadable';

const AnalyticsInsights = AdminLoadable({
  loader: () => import('./AnalyticsConnected'),
  name: 'AnalyticsInsights',
});

export { AnalyticsInsights as default };
